/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_TagsInputs */

const en_options_quicktools_tags = /** @type {(inputs: Options_Quicktools_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const fr_options_quicktools_tags = /** @type {(inputs: Options_Quicktools_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const de_options_quicktools_tags = /** @type {(inputs: Options_Quicktools_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const it_options_quicktools_tags = /** @type {(inputs: Options_Quicktools_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etichette`)
};

const ru_options_quicktools_tags = /** @type {(inputs: Options_Quicktools_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги`)
};

const es_options_quicktools_tags = /** @type {(inputs: Options_Quicktools_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const zh_cn2_options_quicktools_tags = /** @type {(inputs: Options_Quicktools_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签`)
};

const ja_options_quicktools_tags = /** @type {(inputs: Options_Quicktools_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ`)
};

const hi_options_quicktools_tags = /** @type {(inputs: Options_Quicktools_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग`)
};

const pt_pt2_options_quicktools_tags = /** @type {(inputs: Options_Quicktools_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Options_Quicktools_TagsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_tags = /** @type {((inputs?: Options_Quicktools_TagsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_TagsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_tags(inputs)
	if (locale === "de") return de_options_quicktools_tags(inputs)
	if (locale === "it") return it_options_quicktools_tags(inputs)
	if (locale === "ru") return ru_options_quicktools_tags(inputs)
	if (locale === "es") return es_options_quicktools_tags(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_tags(inputs)
	if (locale === "ja") return ja_options_quicktools_tags(inputs)
	if (locale === "hi") return hi_options_quicktools_tags(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_tags(inputs)
	return en_options_quicktools_tags(inputs)
});